import { supabase } from './supabaseClient';
import { takeHandoff } from './handoffCapture';

// Session handoff from web3kurzus.hu — step 2: sign in with the tokens.
//
// One shared promise, so the handoff runs exactly once even when an effect
// runs twice (StrictMode) — and every caller waits for the same result.
// It always resolves: an invalid or expired token simply leaves the user
// signed out, and the normal login page follows. Errors are not logged,
// because the error object can echo the token.

let settled = null;

export function settleHandoff() {
  if (settled) return settled;
  const tokens = takeHandoff();
  settled = tokens
    ? supabase.auth.setSession(tokens).then(() => undefined, () => undefined)
    : Promise.resolve();
  return settled;
}
